export const SIM_CREATE_URL = 'https://t.corp.amazon.com/create/options';

export const COPY_FROM_TEMPLATE_ISSUE = {
    CATEGORY: 'Digital Media Technology',
    TYPE: 'Music PAPER - Labels Processing',
    ITEM: 'Origami UI Issues',
    SEVERITY: 'THREE'
};
